export default {
  USER_IDENTITY: 1,
  STORE_IDENTITY: 2,
  PAY_AMOUNT: 3,
  VOUCHER: 4,
}